import { MarkType, Schema } from 'prosemirror-model';
import { wrapInList, liftListItem } from 'prosemirror-schema-list';
import { toggleMark, setBlockType } from 'prosemirror-commands';
import { EditorState } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { hasParentNodeOfType } from '../utils/findNodes';
import schema from '../richSchema';

const defaultMenuItem = {
  status: 'enabled',
  onKeypress(state, dispatch, editorView) {
    // @ts-ignore
    if (this.statusCheck(state) !== 'disabled') {
      // @ts-ignore
      this.command(state, dispatch, editorView);
    }

    return true;
  }
};

export function createMenuItem(options, defaultOptions) {
  return { ...defaultMenuItem, ...(defaultOptions || {}), ...options };
}

export function createMarkItem(options) {
  const defaultOptions = {
    statusCheck(state) {
      let { from, $from, to, empty, node } = state.selection;
      if (node && node.type.name === 'image_with_link') return 'disabled';

      const active = empty
        ? options.spec.isInSet(state.storedMarks || $from.marks())
        : state.doc.rangeHasMark(from, to, options.spec);

      return active ? 'active' : 'enabled';
    },
    command: toggleMark(options.spec)
  };

  return createMenuItem(options, defaultOptions);
}

export function createImageItem(options) {
  const defaultOptions = {
    status: 'enabled',
    statusCheck(state) {
      let { from, $from, to, empty, node } = state.selection;
      if (node) {
        return node.type.name !== 'image_with_link' ? 'active' : 'disabled';
      } else {
        const active = empty
          ? schema.marks.link.isInSet(state.storedMarks || $from.marks())
          : state.doc.rangeHasMark(from, to, schema.marks.link);

        return active ? 'disabled' : 'enabled';
      }
    }
  };

  return createMenuItem(options, defaultOptions);
}

export function createBlockmarkItem(options) {
  const defaultOptions = {
    statusCheck(state) {
      const { $from, to, node } = state.selection;
      if (node && node.type.name === 'image_with_link') return 'disabled';

      const active = node
        ? node.hasMarkup(options.spec, { level: options.level })
        : to <= $from.end() && $from.parent.hasMarkup(options.spec, { level: options.level });

      return active ? 'active' : 'enabled';
    },
    command: setBlockType(options.spec, { level: options.level })
  };

  return createMenuItem({ ...defaultOptions, ...options });
}

export function createParagraphItem(options) {
  const defaultOptions = {
    statusCheck(state) {
      let { $from, to, node } = state.selection;
      const active = node
        ? node.hasMarkup(options.spec)
        : to <= $from.end() && $from.parent.hasMarkup(options.spec);

      return active ? 'active' : 'enabled';
    },
    command: setBlockType(options.spec)
  };

  return createMenuItem({ ...defaultOptions, ...options });
}

export function createListItem(options) {
  const defaultOptions = {
    statusCheck(state) {
      if (
        hasParentNodeOfType(options.disableIfNodeSpec)(state.selection) ||
        (state.selection.node && state.selection.node.type.name === 'image_with_link')
      ) {
        return 'disabled';
      }

      return hasParentNodeOfType(options.spec)(state.selection) ? 'active' : 'enabled';
    },
    command: (state, dispatch, editorView) => {
      hasParentNodeOfType(options.spec)(state.selection)
        ? liftListItem(options.listItemNodeSpec)(state, dispatch)
        : wrapInList(options.spec)(state, dispatch);
    }
  };

  return createMenuItem({ ...defaultOptions, ...options });
}

export function createHeadingItem(level, schema) {
  return createBlockmarkItem({
    spec: schema.nodes.heading,
    name: `H${level}`,
    level: level
  });
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/MenuItem.js